/**
 * FileAttachmentsList - Modern card-based UI for file attachments with download
 */

import { Download, Paperclip } from 'lucide-react';
import { downloadFile } from '../utils/fileDownload';

export type FileAttachmentsListProps = {
  files: Array<{ id: number; name: string; api_url?: string; content_type?: string }>;
};

export function FileAttachmentsList({ files }: FileAttachmentsListProps) {
  if (!files || files.length === 0) {
    return <span className="text-gray-500 dark:text-gray-400">No attachments</span>;
  }

  const handleDownload = async (file: { id: number; name: string; api_url?: string }) => {
    try {
      if (!file.id) {
        console.error('No file ID available');
        return;
      }

      await downloadFile(file.id, file.name);
    } catch (error) {
      console.error('Download failed:', error);
      alert(`Failed to download ${file.name}`);
    }
  };

  return (
    <div className="space-y-2">
      {files.map((file) => (
        <div
          key={file.id}
          className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="flex-shrink-0 p-2 bg-blue-100 dark:bg-blue-900/30 rounded">
              <Paperclip size={16} className="text-blue-600 dark:text-blue-400" />
            </div>
            <span className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{file.name}</span>
          </div>
          {file.api_url ? (
            <button
              onClick={() => handleDownload(file)}
              className="flex-shrink-0 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
              title="Download file"
            >
              <Download size={16} className="text-gray-600 dark:text-gray-400" />
            </button>
          ) : (
            <span className="text-xs text-gray-500 dark:text-gray-500">N/A</span>
          )}
        </div>
      ))}
    </div>
  );
}
